import React from 'react';

const ArrowRightIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6px" height="13px" viewBox="0 0 6 12" version="1.1">
      <g id="surface1">
        <path stroke={'none'} fillRule={'nonzero'} fill={'currentColor'} d="M 0.515625 11.816406 C 0.308594 11.816406 0.121094 11.695312 0.0390625 11.511719 C -0.0390625 11.328125 0.00390625 11.117188 0.152344 10.976562 L 4.359375 6.953125 C 4.960938 6.375 4.960938 5.441406 4.359375 4.863281 L 0.152344 0.839844 C 0.0195312 0.714844 -0.03125 0.535156 0.015625 0.363281 C 0.0625 0.191406 0.203125 0.0585938 0.378906 0.015625 C 0.558594 -0.03125 0.75 0.0195312 0.878906 0.144531 L 5.085938 4.167969 C 6.089844 5.128906 6.089844 6.6875 5.085938 7.648438 L 0.878906 11.671875 C 0.78125 11.765625 0.652344 11.816406 0.515625 11.816406 Z M 0.515625 11.816406 "/>
      </g>
    </svg>
  );
};

export default ArrowRightIcon;
